import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintEntityDetail } from '.';

/**
 * @component {kat-blueprint-entity-detail-identify} KatBlueprintEntityDetailIdentify Component used to place and filter components within the identify section.
 * @slot default Blueprint content for identify section.
 */
@register(KatBlueprintEntityDetail.slotMapping.identify.name)
export class KatBlueprintEntityDetailIdentify extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintEntityDetail.slotMapping.identify.name,
      KatBlueprintEntityDetail.slotMapping.identify.allowed
    );
  }
}
